import apiendpoins from "../constants/apiendpoins";
import { apiService } from "./common";

export const getUsers = (phase_id?: any) => {
  return apiService(
    `${apiendpoins.fetchUsers}${phase_id ? `?phase_id=${phase_id}` : ""}`,
    "GET"
  );
};

export const addUser = (payload: any) => {
  return apiService(apiendpoins.addUser, "POST", payload);
};

export const updateUser = (payload: any) => {
  return apiService(apiendpoins.updateUser, "PUT", payload);
};

export const deleteUser = (id: string) => {
  return apiService(`${apiendpoins.deleteUser}?id=${id}`, "DELETE");
};

export const truncateUsers = (phase_id?: any) => {
  return apiService(
    `${apiendpoins.truncateUsers}${phase_id ? `?phase_id=${phase_id}` : ""}`,
    "DELETE"
  );
};

export const getAllPhases = () => {
  return apiService(`${apiendpoins.phases}`, "GET");
};
